module.exports = __webpack_public_path__ + "assets/failure-icon-9ca33e.svg";